// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__huykA","footer1":"Footer_footer1__6hjqW","avatar1":"Footer_avatar1__B4jhG","avatar2":"Footer_avatar2__W87w0"};